import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { Router, NavigationError } from '@angular/router';
import { UpdateService } from '@pulpo/pulpo-commons';
import { LoadingService } from 'libs/pulpo-commons/src/lib/services/loading.service';
import { AuthService, TabSyncService } from '@pulpo/pulpo-api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private tabSyncUnsub?: () => void;

  constructor(
    public router: Router,
    public loadingService: LoadingService,
    private renderer: Renderer2,
    private updateService: UpdateService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private tabSyncService: TabSyncService
  ) {}

  ngOnInit() {
    this.updateService.setup();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError && event.error.status === 404) {
        this.router.navigate(['/404']);
      }
      this.cdr.markForCheck();
    });

    this.loadingService.isLoading.subscribe((isLoading) => {
      if (isLoading) {
        this.renderer.addClass(document.body, 'no-scroll');
      } else {
        this.renderer.removeClass(document.body, 'no-scroll');
      }
      this.cdr.markForCheck();
    });

    this.tabSyncUnsub = this.tabSyncService.listen(
      () => {
        this.authService.logoutLocal();
        this.router.navigate(['/account/login']);
      },
      (_at, _rt) => {
        // Token mis à jour dans localStorage par l'autre onglet — rien à faire
      }
    );
  }

  ngOnDestroy() {
    this.tabSyncUnsub?.();
  }
}
